import { t } from '@lingui/macro';
import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import toast from 'react-hot-toast';
import useSWRMutation from 'swr/mutation';
import { type ParamsSchemaT, updateSkill } from '../utils/update-skill';

export function useUpdateSkill() {
  const { client } = useApi();

  return useSWRMutation(
    'update-quark-skill',
    (key, { arg }: SWRArgs<ParamsSchemaT>) => {
      return toast.promise(updateSkill(client, arg), {
        loading: t`Mise à jour de la compétence.`,
        success: t`La compétence a bien été mise à jour.`,
        error: t`Une erreur est survenue lors de la mise à jour de la compétence.`,
      });
    }
  );
}
